var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLetterW(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.3447,
    cy: 11.8821,
    r: 11.3821,
    fill: "#F0F3F9",
    stroke: "#8194D5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.991 16H8.639L6.156 6.965H7.287L9.38 14.687L11.538 6.965H12.682L14.931 14.687L16.92 6.965H18.064L15.581 16H14.216L12.11 8.629L9.991 16Z",
    fill: "#657CCC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetterW);
export default __webpack_public_path__ + "static/media/letterW.c15c53c36cf3b2ddbd6e37977a343a8d.svg";
export { ForwardRef as ReactComponent };